const STORAGE_KEY = 'rocket-soccer.guest-identity.v1';

export interface GuestIdentity {
  readonly id: string;
  readonly displayName: string;
}

export function loadOrCreateGuestIdentity(storage?: Storage): GuestIdentity {
  try {
    storage ??= window.localStorage;
    const stored = storage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed: unknown = JSON.parse(stored);
      if (isGuestIdentity(parsed)) return parsed;
    }
  } catch {
    // Browser storage may be unavailable; guest play does not require persistence.
  }

  const id = crypto.randomUUID();
  const identity = Object.freeze({
    id,
    displayName: `Guest-${id.replaceAll('-', '').slice(0, 5)}`,
  });
  try {
    storage?.setItem(STORAGE_KEY, JSON.stringify(identity));
  } catch {
    // Keep this identity for the current page when persistence is denied or full.
  }
  return identity;
}

function isGuestIdentity(value: unknown): value is GuestIdentity {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<GuestIdentity>;
  return typeof candidate.id === 'string'
    && candidate.id.length > 0
    && typeof candidate.displayName === 'string'
    && /^Guest-[0-9a-f]{5}$/i.test(candidate.displayName);
}
